import { render, staticRenderFns } from "./ActivePrescriptions.vue?vue&type=template&id=2fa35a2c"
import script from "./ActivePrescriptions.vue?vue&type=script&lang=js"
export * from "./ActivePrescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports